import { getShareModalConfig } from 'lib/customer/getShareModalConfig'
import { useMemo } from 'react'
import { useAppSelector } from './reduxHooks'

interface Props {
  utmCampaign?: string;
  location?: string;
  offerId?: string;
  image?: App.Image;
  queryString?: string;
  type: 'offer' | 'bedbankOffer' | 'experience' | 'carHire';
}

function useShareModalConfig(props: Props) {
  const url = useAppSelector((state) => state.config.customerPortalURL)
  const memberId = useAppSelector((state) => state.auth.account.memberId)
  const pathname = useAppSelector((state) => state.router.location.pathname)
  const region = useAppSelector((state) => state.geo.currentRegionCode)

  const config = useMemo(() => getShareModalConfig({
    customerPortalURL: url,
    memberId,
    offerId: props.offerId,
    offerLocation: props.location,
    pathname,
    region,
    type: props.type,
    utmCampaign: props.utmCampaign,
    image: props.image,
    queryString: props.queryString,
  }), [
    props.image,
    props.location,
    props.offerId,
    props.utmCampaign,
    props.type,
    url,
    memberId,
    pathname,
    region,
    props.queryString,
  ])

  return config
}

export default useShareModalConfig
